import FileSaver from 'file-saver';

import { TOKEN_KEY } from '@lib/providers/auth';

import { QueryResourceDto, ScanAllPlayersDto, ScanPlayersDto } from '@services/_api';
import client from '@services/client';

export type { ScanHistoryResponseDto, ScanHistoryItemDto, QueryResourceDto } from '@services/_api';

export const scanPlayers = async (body: ScanPlayersDto) => {
  return client.api.scanPlayersControllerScan(body);
};

export const scanAllPlayers = async (body: ScanAllPlayersDto) => {
  return client.api.scanPlayersControllerScanAll(body);
};

export const queryResource = async (body: QueryResourceDto) => {
  return client.api.scanPlayersControllerQueryResource(body);
};

export type ScanStatus =
  | { running: false }
  | {
      running: true;
      taskId: number;
      kind: 'scan' | 'load-more' | 'scan-all' | 'query-resource';
      scannedCount: number;
      matchedCount: number;
    };

export const getScanStatus = async () => {
  return client.api.scanPlayersControllerGetScanStatus();
};

// Scan Players' own task-status endpoint, not the shared generic GET /task-queue/:id (see
// ScanPlayersController.getTaskStatus) - keeps the polling loop below decoupled from that
// shared controller entirely.
export const getScanTaskStatus = async (taskId: number) => {
  return client.api.scanPlayersControllerGetTaskStatus(taskId.toString());
};

export const cancelScan = async () => {
  return client.api.scanPlayersControllerCancelScan();
};

export const getScanHistory = async (skip: number, take: number) => {
  return client.api.scanPlayersControllerGetHistory({ skip: String(skip), take: String(take) });
};

export const downloadScanPlayersResult = async (
  fileName: string,
  format: 'txt' | 'json' = 'txt',
): Promise<void> => {
  const token = localStorage.getItem(TOKEN_KEY);
  const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

  const response = await fetch(`${baseUrl}/api/cstool/scan-players/download/${fileName}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => undefined);
    throw new Error(error?.message || 'Failed to download scan result');
  }

  const blob = await response.blob();
  FileSaver.saveAs(blob, `scan-players-${fileName}.${format}`);
};
